import React from "react";
import { Quote } from "lucide-react";
import { useSite } from "./PublicLayout";

export default function Testimonials() {
  const { site } = useSite();
  const items = site?.testimonials || [];
  const logos = site?.logos || [];
  if (!items.length && !logos.length) return null;
  return (
    <section data-testid="testimonials" className="border-y s-border s-elev">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {logos.length > 0 && (
          <div data-testid="logo-strip" className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 mb-12">
            <span className="font-mono text-[10px] uppercase tracking-widest s-text2 w-full text-center md:w-auto">Trusted by security-minded teams</span>
            {logos.map((l) => l.url
              ? <img key={l.id} src={l.url} alt={l.name} title={l.name} className="h-7 opacity-70 grayscale hover:grayscale-0 hover:opacity-100 transition-opacity duration-200" />
              : <span key={l.id} data-testid={`logo-${l.id}`} className="font-heading font-bold text-lg s-text2 tracking-tight opacity-80">{l.name}</span>)}
          </div>
        )}
        {items.length > 0 && (
          <div className="grid md:grid-cols-3 gap-6">
            {items.map((t) => (
              <figure key={t.id} data-testid={`testimonial-${t.id}`} className="s-card p-6 flex flex-col">
                <Quote size={18} className="s-primary mb-3" />
                <blockquote className="text-sm leading-relaxed flex-1">“{t.quote}”</blockquote>
                <figcaption className="mt-5 pt-4 border-t s-border">
                  <div className="font-semibold text-sm">{t.name}</div>
                  <div className="font-mono text-[10px] uppercase tracking-widest s-text2 mt-0.5">{t.title}{t.company ? ` · ${t.company}` : ""}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
